import { Language, SchedulingTimeFrames } from '@breathelife/types';
import { CloudinaryProps } from '@breathelife/ui-components';

import { LocalizationStrings } from './Localization';
import { DayOfTheWeek } from '../../ScheduleTimeTable/Weekdays';
import { OnSubmitScheduleDataType } from '../../ContactForm';

export enum ViewTabs {
  callUs,
  callYou,
}

export type ContactPersonInfo = { name: string; title: string; imgUrl?: string };

export type OpeningHoursType = Partial<Record<DayOfTheWeek, string>>;

export type FormProps = Partial<OnSubmitScheduleDataType> & {
  schedulingTimeFrames: SchedulingTimeFrames;
  onSubmitSchedule: (onSubmitContactArgs: OnSubmitScheduleDataType) => void;
  isSubmitting?: boolean;
  isSubmitted?: boolean;
};

export type BaseContactAdvisorModalProps = {
  form: FormProps;
  language: Language;
  localizationStrings: LocalizationStrings;
  customerServicePhoneNumber?: string;
  customerServiceEmail?: string;
  carrierContactPhoneNumber?: string;
  carrierContactEmail?: string;
  contactPersonInfo?: ContactPersonInfo;
  securityDisclosure?: string;
  cloudinaryProps?: CloudinaryProps;
  openingHours?: OpeningHoursType;
  referenceNumber?: string;
  useMobileStylingOnDesktop?: boolean;
  hideEmail?: boolean;
  hidePhone?: boolean;
  isPlural?: boolean;
};
